import { css } from '@emotion/css';
import { WarningIcon } from '../assets/icons';
import { Colors } from '../styles/colors';
import { p1Style } from '../styles/text';

export const NoPermission = (): JSX.Element => {
  return (
    <div className={containerStyle}>
      <div className={iconWrapStyle}>
        <WarningIcon className={imageStyle} height={48} width={48} />
      </div>
      <div
        className={textStyle}
      >{`You don't have a permission to view this`}</div>
    </div>
  );
};

const textStyle = css`
  ${p1Style}
  color: ${Colors.TEXT_SECONDARY};
  padding-top: 1.5rem;
`;

const iconWrapStyle = css`
  align-self: center;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background: ${Colors.SURFACE};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const imageStyle = css`
  color: ${Colors.TEXT_SECONDARY};
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  justify-self: center;
  height: 60vh;
  justify-content: center;
`;
